export const getDaysInCurrentMonth = () => {
  const now = new Date();
  // Day 0 of the next month is the last day of this one.
  return new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
};

/**
 * Day of the current month as a number (1-31).
 * Deliberately not toLocaleDateString(): under locales with non-Latin numerals
 * that returns e.g. "١٥", which turns every downstream calculation into NaN.
 */
export const getToday = () => new Date().getDate();

/**
 * How far through the current month we are, as a percentage (0-100).
 * @returns {number}
 */
export const calculatePercentThruMonth = () =>
  (getToday() / getDaysInCurrentMonth()) * 100;
